import React, { createContext, useContext, useState } from 'react';

interface QuoteContextType {
  openQuote: () => void;
  closeQuote: () => void;
  isQuoteOpen: boolean;
}

const QuoteContext = createContext<QuoteContextType>({ openQuote: () => {}, closeQuote: () => {}, isQuoteOpen: false });

export const useQuote = () => useContext(QuoteContext);

export const QuoteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  return (
    <QuoteContext.Provider value={{ openQuote: () => setIsQuoteOpen(true), closeQuote: () => setIsQuoteOpen(false), isQuoteOpen }}>
      {children}
    </QuoteContext.Provider>
  );
};
